//from http://ridiculousfish.com/blog/posts/colors.html
export const MAP_COLORS = [
	'rgb(77, 148, 255)',
	'rgb(255, 184, 77)',
	'rgb(255, 77, 237)',
	'rgb(77, 255, 94)',
	'rgb(139, 77, 255)',
	'rgb(193, 255, 77)',
	'rgb(255, 77, 103)',
	'rgb(77, 255, 228)',
	'rgb(77, 79, 255)',
	'rgb(255, 252, 77)',
	'rgb(255, 77, 169)',
	'rgb(77, 255, 163)',
	'rgb(207, 77, 255)',
	'rgb(124, 255, 77)',
	'rgb(255, 118, 77)',
	'rgb(77, 213, 255)',
	'rgb(77, 115, 255)',
	'rgb(255, 216, 77)',
	'rgb(255, 77, 204)',
	'rgb(77, 255, 127)',
	'rgb(172, 77, 255)',
	'rgb(160, 255, 77)',
	'rgb(255, 82, 77)',
	'rgb(77, 249, 255)',
	'rgb(106, 77, 255)',
	'rgb(225, 255, 77)',
	'rgb(255, 77, 136)',
	'rgb(77, 255, 196)',
	'rgb(240, 77, 255)',
	'rgb(91, 255, 77)',
	'rgb(255, 151, 77)',
	'rgb(77, 181, 255)',
	'rgb(77, 130, 255)',
	'rgb(255, 201, 77)',
	'rgb(255, 77, 219)',
	'rgb(77, 255, 112)',
	'rgb(157, 77, 255)',
	'rgb(175, 255, 77)',
	'rgb(255, 77, 85)',
	'rgb(77, 255, 246)'
];

export const DEFAULT_PLACEMARK_ITEM_STYLES = {
	polygon: {
		strokeColor: '#333',
		strokeWeight: 1
	},
	polyline: {
		strokeWeight: 8
	},
	marker: {
		strokeColor: '#333',
		strokeWeight: 1
	}
};

/** ROADMAP styles: keep administrative boundaries and road labels on. */
export const MAP_BOUNDARY_AND_LABEL_STYLES = [
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [{ visibility: 'on' }, { color: '#5c5c5c' }, { weight: 1 }]
	},
	{
		featureType: 'administrative.country',
		elementType: 'geometry.stroke',
		stylers: [{ visibility: 'on' }, { color: '#3d3d3d' }, { weight: 1.6 }]
	},
	{
		featureType: 'administrative.country',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'administrative.province',
		elementType: 'geometry.stroke',
		stylers: [{ visibility: 'on' }, { color: '#4a4a4a' }, { weight: 1.3 }]
	},
	{
		featureType: 'administrative.province',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'administrative.locality',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'road.highway',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'road.local',
		elementType: 'labels',
		stylers: [{ visibility: 'on' }]
	},
	{
		featureType: 'poi',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'poi.business',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'transit',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }]
	}
];

/**
 * Use ROADMAP plus styles so state/county boundaries and road labels stay visible.
 * Vector Feature Layers are applied when a Map ID allows it.
 */
export function applyMapLabelsAndBoundaries(map) {
	if (!map || !window.google || !google.maps) {
		return;
	}

	map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
	map.setOptions({
		styles: MAP_BOUNDARY_AND_LABEL_STYLES,
		clickableIcons: false
	});

	const FeatureType = google.maps.FeatureType;
	if (!FeatureType || typeof map.getFeatureLayer !== 'function') {
		return;
	}

	const layerTypes = [
		FeatureType.COUNTRY,
		FeatureType.ADMINISTRATIVE_AREA_LEVEL_1,
		FeatureType.ADMINISTRATIVE_AREA_LEVEL_2
	];

	layerTypes.forEach(type => {
		try {
			const layer = map.getFeatureLayer(type);
			layer.style = {
				strokeColor: type === FeatureType.ADMINISTRATIVE_AREA_LEVEL_1 ? '#333333' : '#666666',
				strokeOpacity: 0.9,
				strokeWeight: type === FeatureType.ADMINISTRATIVE_AREA_LEVEL_1 ? 1.6 : 1,
				fillOpacity: 0
			};
		} catch {
			// Feature layers require a Cloud vector Map ID.
		}
	});
}

export const SELECTED_PLACEMARK_ITEM_STYLES = {
	polygon: {
		strokeColor: '#000',
		strokeWeight: 4
	},
	polyline: {
		strokeWeight: 4
	},
	marker: {
		strokeColor: '#000',
		strokeWeight: 4
	}
};